function getHost(): string {
	return process.env.REACT_APP_API_URL || `${window.location.protocol}//${window.location.host}`;
}

function getIngestURL(): string {
	return `${getHost()}/api/v1/ingest`;
}

export { getHost, getIngestURL };
